import { Component, EventEmitter, HostListener, Input, OnInit, Optional, Output, inject } from '@angular/core';
import { Beneficiary, MoniepointBeneficiaryModel } from '../../../../../../shared/models/transfer.model';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';

@Component({
	selector: 'app-beneficiary-modal',
	templateUrl: './beneficiary-modal.component.html',
	styleUrls: ['./beneficiary-modal.component.scss']
})
export class BeneficiaryModalComponent implements OnInit {
	searchParams: string;
	customerSearchParam: string;
	moniepointBeneficiaries: MoniepointBeneficiaryModel[] = [];
	filteredMoniepointBeneficiaries: MoniepointBeneficiaryModel[] = [];
	@Input() newTransferView: boolean;
	@Input() cantManage = false;
	@Input() beneficiaries: MoniepointBeneficiaryModel[];
	@Output() selectedBeneficiaryEmmiter = new EventEmitter();
	@Output() manageBeneficiariesEmmiter = new EventEmitter();
	selectedBeneficiaryItem: MoniepointBeneficiaryModel;
	breakPoint = 900;
	isMobile = false;
	readonly nzModalData = inject(NZ_MODAL_DATA, { optional: true }) ?? {};

	constructor(@Optional() private modalService: NzModalRef) {
	}

	@HostListener('window:resize', ['$event'])
	onResize(_event): void {
		this.setMobile(window.innerWidth);
	}

	setMobile(browserWidth: number) {
		this.isMobile = browserWidth <= this.breakPoint;
	}

	ngOnInit(): void {
		if(!this.isMobile) this.modalService.componentInstance = { ...this.modalService.componentInstance, ...this.nzModalData };
		this.moniepointBeneficiaries = this.modalService?.componentInstance?.data?.beneficiaries;
		if (this.beneficiaries) {
			this.moniepointBeneficiaries = this.beneficiaries;
		}
		this.filteredMoniepointBeneficiaries = this.moniepointBeneficiaries;
		this.onResize(window.innerWidth);
		if(!this.isMobile)this.newTransferView = this.modalService?.componentInstance?.data.newTransferView;
		if(!this.isMobile )this.cantManage = this.modalService?.componentInstance?.data.cantManage;
	}

	selectedBeneficiary(beneficiary) {
		this.selectedBeneficiaryItem = beneficiary;
		if(this.isMobile){
			this.selectedBeneficiaryEmmiter?.emit(beneficiary);
			this.modalService?.componentInstance?.callback(beneficiary);
		}
	}

	filterBeneficiaries(text: string){
		this.filteredMoniepointBeneficiaries = this.moniepointBeneficiaries.filter((beneficiary)=> beneficiary.beneficiaryName?.toLowerCase().includes(text.toLowerCase()));
	}

	confrimBeneficiary() {
		this.modalService.componentInstance.callback(this.selectedBeneficiaryItem);
	}

	getInitials(beneficiaryName: string) {
		if (beneficiaryName) {
			let initials = '';
			const fullName = beneficiaryName.split(' ');
			for (const item of fullName) {
				if (initials.length === 2) {
					break;
				}
				initials += item.charAt(0);
			}
			return initials.toUpperCase();
		} else {
			return '';
		}
	}

	closeModal() {
		this.modalService.destroy();
	}

	manageBenficiaries() {
		if (this.beneficiaries) {
			this.manageBeneficiariesEmmiter.emit({ action: 'manage_beneficiaries' });
		} else {
			this.modalService.componentInstance.callback(
				{ action: 'manage_beneficiaries' }
			);
		}
	}
}
